<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("create_stock_adjustment")}}</h4>
                <p class="text-subtitle-1">{{$t("adjustment_inventory_stock")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <StockAdjustmentForm
                    ref="form"
                    v-model="data"
                    :warehouseId="warehouseId"
                    />
            </v-col>
        </v-row>
        <v-row class="my-2">
            <v-col cols="12" md="3">
                <v-btn color="primary" block @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    {{$t("save")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn depressed block @click="onCancel">
                    {{$t("cancel_btn")}}
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import stockAdjustment from "./../../services/stockJournal/stockAdjustment"

import PAlert from '@/components/common/PAlert'
import StockAdjustmentForm from './../../components/warehouse/StockAdjustmentForm.vue';
import { v4 as uuid } from 'uuid';
export default {
    components: {
        StockAdjustmentForm,
        PAlert
    },
    data() {
        return {
            data: {},
            idempotentKey: null,
            loading: false,
            warehouseId: null,
            alert: {
                value: false,
                title: null,
                content: "Are you sure?",
                callback: null
            }
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, value: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save};
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            stockAdjustment.store({...this.data, idempotentKey: this.idempotentKey, warehouse_id: this.warehouseId}).then(response => {
                this.$router.replace({
                    name: "AdjustmentDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            });
        },
        onCancel() {
            this.alert = {...this.alert, value: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel};
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.idempotentKey = uuid();
        this.warehouseId = this.$route.params.warehouseId;
    }
}
</script>

<style>

</style>